<div class="unregistered">
  <div class="header">
    <img *ngIf="companyLogo | async as logo" alt="logo-img" class="logo" [attr.src]="logo" />
  </div>
  <div class="content">
    <div class="message-box">
      <app-svg-icon src="./assets/icons/ico_lock.svg"></app-svg-icon>
      <div class="main-text">
        {{ 'module.public.unregisteredUser.mainText' | translate }}
      </div>
      <div class="sub-text">
        {{ 'module.public.unregisteredUser.subTextUpper' | translate }}
        <br />
        <a href="mailto:{{ dsoEmail }}"> {{ dsoEmail }}</a>
        <span>,</span>
        <br />
        {{ 'module.public.unregisteredUser.subTextLower' | translate }}
      </div>
    </div>
  </div>
</div>
